<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
            <h2 class="m-2" style="color:#6A1C56" v-if="IncomeCode!=null&&IncomeCode!=undefined&&IncomeCode!='undefined'">
              {{$t('LoginNote')}}
            </h2>
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <img src="@/assets/images/logo/united ats Final LOGO.png" style="width:330px" alt="login" class="mx-auto">
                <!-- <img src="@/assets/images/logo/ebdaaAcademy.png" style="width:180px" alt="login" class="mx-auto"> -->

                <div class="vx-card__title mb-4 mt-5">
                  <h4 class="mb-4">{{$t('Login')}}</h4>
                  <p>{{$t('WelcomeBackPleasLogin')}}.</p>
                </div>
                <login-jwt class="mb-10"></login-jwt>
                <img src="@/assets/images/logo/InClass_Color.png"  style="width:150px" alt="login" class="mx-auto mb-10">

                <!-- <vs-tabs>
                  <vs-tab label="JWT">
                   
                  </vs-tab>

                   <vs-tab label="Firebase">
                    <login-firebase></login-firebase>
                  </vs-tab> 

                   <vs-tab label="Auth0">
                    <login-auth0></login-auth0>
                  </vs-tab> 
                </vs-tabs> -->

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import LoginJwt from "./LoginJWT.vue"
//import LoginFirebase from "./LoginFirebase.vue"
//import LoginAuth0 from "./LoginAuth0.vue"

export default {
  data(){
return {
         IncomeCode:localStorage.getItem('IncomeCode')
        }
  },
  components: {
    LoginJwt,
    //LoginFirebase,
    //LoginAuth0
  },
   created(){
     debugger
     if(this.$route.params.IncomeCode!=null&&this.$route.params.IncomeCode!=undefined&&this.$route.params.IncomeCode!='undefined'){
          localStorage.setItem("IncomeCode", this.$route.params.IncomeCode)
          this.IncomeCode = localStorage.getItem('IncomeCode');
          
        }
  }

}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
